import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { Customer } from '../../gql/graphql';

interface AdvancedTabProps {
	customerData: Partial<Customer>;
	updateCustomerData: (updates: Partial<Customer>) => void;
}

function AdvancedTab({ customerData, updateCustomerData }: AdvancedTabProps) {
	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Advanced Settings
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Additional customer information and metadata
			</Typography>

			<Grid container spacing={3}>
				{/* Customer ID */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="Customer ID"
						name="_id"
						value={customerData._id || 'Auto-generated after save'}
						disabled
						helperText="Unique identifier for this customer"
					/>
				</Grid>

				{/* Future Custom Fields */}
				<Grid item xs={12}>
					<Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
						<Typography variant="body2" color="text.secondary">
							Additional custom fields such as loyalty points, preferences, and notes can be added here in future updates.
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AdvancedTab;
